import React from "react";
import { Link } from "react-router-dom";
import ContactCard from "./ContactCard";
import { useRef } from "react";

const ContactList = (props) => {
  console.log(props);

  const inputEl =useRef ("");

  const deleteContactHandler = (id) => {
    props.getContactId(id);
  };

  // const contacts ={
  //     id:"1",
  //     "name":"Berlia",
  //     "mail":"dk@gmail.com"

  // }


// map the contacts with renderContactList function
  const renderContactList = props.contacts.map((contact) => {
    return (
      <ContactCard
        contact={contact}
        clickHandler={deleteContactHandler}
        key={contact.id}
      />
    );
  });

  const getSearchTerm=()=>{
    props.searchKeyword(inputEl.current.value)

  };


  return (
    <div className="main">
      <h2>
        Contact List
        <Link to="/add">
          <button className="ui button blue right">Add Contact</button>
        </Link>
      </h2>
      <div className="ui inverted segment">
        <div className="ui inverted input ">
        {/* binding useref with input */}
          <input ref={inputEl} type="text" placeholder="Search Contacts" className="prompt" value={props.term} onChange={getSearchTerm}/>
          {/* <i className="search icon"></i> */}

        </div>
      </div>

      <div className="ui celled list">{renderContactList.length>0 ? renderContactList : "No Contacts Available"}</div>
    </div>
  );
};

export default ContactList;
